"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _CurrencyLabelFormatters = require("../internal/utils/CurrencyLabelFormatters");

var _default = _react.default.createClass({
  displayName: "FormattedCurrencyLabel",
  propTypes: {
    currencyCode: _react.PropTypes.string.isRequired,
    currencyStyle: _react.PropTypes.oneOf(Object.keys(_CurrencyLabelFormatters.currencyFormatters))
  },
  getDefaultProps: function getDefaultProps() {
    return {
      currencyStyle: _CurrencyLabelFormatters.currencyStyles.short
    };
  },
  render: function render() {
    var _this$props = this.props,
        currencyCode = _this$props.currencyCode,
        currencyStyle = _this$props.currencyStyle,
        passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["currencyCode", "currencyStyle"]);
    return _react.default.createElement("span", passThroughProps, _CurrencyLabelFormatters.currencyFormatters[currencyStyle](currencyCode));
  }
});

exports.default = _default;
module.exports = exports.default;